import axios from '../../localAxios';
import { purgeURL } from '../url';

export interface PurgeQuizFolderParam {
  folderIds: number[];
  quizIds: number[];
}

export type PurgeQuizResponse = Record<string, never>;

export async function purgeQuizFolder({
  folderIds,
  quizIds,
}: PurgeQuizFolderParam) {
  const url = purgeURL();
  const response = await axios.put<PurgeQuizResponse>(url.href, {
    folderIds: folderIds,
    quizIds: quizIds,
  });
  return response.data;
}
